import styled from 'styled-components'
import { Spinner } from 'lib/ui/components'
import { buttonPrimary, formInputCss } from 'app/sofia/resources/theme/css'

export const CouponContainer = styled.div`
  padding: 15px 0;
  border-bottom: 1px solid ${props => props.theme.palette.general.borderColor};

  p {
    margin: 20px 0;
    font-size: 14px;
    color: ${props => props.theme.palette.general.greyDark};

    strong {
      display: block;
      color: ${props => props.theme.palette.general.strong};
      padding: 10px 0;
      font-size: 16px;
      border-top: 1px solid ${props => props.theme.palette.general.borderColor};
      border-bottom: 1px solid ${props => props.theme.palette.general.borderColor};
    }
  }

  button {
    ${buttonPrimary}

    > div {
      padding: 0;
    }
  }
`

export const FormContainer = styled.div`
  padding: 15px 0 20px;
  border-bottom: 1px solid ${props => props.theme.palette.general.borderColor};

  form {
    display: flex;
    align-items: flex-end;
    justify-content: space-evenly;

    > div {
      margin: 0;
      padding-bottom: 0;
    }

    input {
      ${formInputCss}
    }

    > button {
      ${buttonPrimary}
      padding: 12px 25px;
      margin-left: 5px;

      > div {
        padding: 0;
      }

      ${Spinner} {
        transform: translateY(-4px);
      }
    }
  }
`
